import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AssessmentComponent } from './assessment/assessment.component';
import { ViewAssessmentComponent } from './view-assessment/view-assessment.component';
import { LibReportModule } from '@ui-components/report';
import { LibModule } from '@ui-components/lib.module';
import { QuestionComponent } from './question/question.component';
import { RankingComponent } from './ranking/ranking.component';
import { TextComponent } from './text/text.component';
import { SingleChoiceComponent } from './single-choice/single-choice.component';
import { StatusBarComponent } from './status-bar/status-bar.component';
import { CompleteComponent } from './complete/complete.component';
import { RouterModule } from '@angular/router';
import { RespectComponent } from './respect/respect.component';
import { ReactiveFormsModule } from '@angular/forms';
import { VideoGuideComponent } from './video-guide/video-guide.component';

@NgModule({
  declarations: [
    AssessmentComponent,
    CompleteComponent,
    QuestionComponent,
    RankingComponent,
    SingleChoiceComponent,
    TextComponent,
    ViewAssessmentComponent,
    StatusBarComponent,
    RespectComponent,
    VideoGuideComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    LibReportModule,
    LibModule,
    ReactiveFormsModule
  ],
  exports: [
    AssessmentComponent,
    ViewAssessmentComponent
  ],
})
export class AssessmentsModule { }
